import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import BrowserWindowObjectService from '../../services/browserWindowObjectService';
import isDateValidator from '../../validators/isDateValidator';
import FormControl from '../../models/formControl';
import DateHandler from '../../models/dateHandler';
import { ConfirmResult } from '../../models/alertifyPromise';
import PopupHelper from '../../models/popupHelper';
import { MessageQueService } from '../../services/index';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  providers: [MessageQueService]
})
export default class ReportsComponent implements OnInit {
  constructor(private browserWindowObjectService: BrowserWindowObjectService,
    private formBuilder: FormBuilder, private msgSvc: MessageQueService,
    private router: Router) { }

  ngOnInit(): void {
    this.msgSvc.setControlKey();
    this.reportsPageForm = this.formBuilder.group({
      startDate: ['', [
          Validators.required,
          isDateValidator(2000)
        ]
      ],
      endDate: ['', [
        Validators.required,
        isDateValidator(2000)
        ]
      ],
      invoiceNumber: [''],
      openReportInTab: ['']
    });

    this.formControl = new FormControl(this.reportsPageForm);
  }

  showInvoiceReportGeneratorSection() {
    this.showInvoiceReportGenerator = true;
  }

  onSubmit() {
    const form = this.reportsPageForm.value;
    const startDate = this.convertDateToString(form.startDate, 2000, 'MM-DD-YYYY');
    const endDate = this.convertDateToString(form.endDate, 2000, 'MM-DD-YYYY');
    const route = `invoiceReport/${startDate}/${endDate}/${form.invoiceNumber}`;
    if (form.openReportInTab) {
      this.browserWindowObjectService.openWindowITabByRoute(route, form.invoice);
    } else {
      this.browserWindowObjectService.openWindowInNewWindowByRoute(route, form.invoice, 1000, 900);
    }

  }

  formatDate(controlName: string, baseCentury: number) {
    if (!this.formControl.hasErrorByControlName(controlName)) {
      const value = this.formControl.getValueByControlName(controlName);
      this.formControl.setValueByControlName(controlName, this.convertDateToString(value, baseCentury));
    }
  }

  goToNavigation() {
    this.router.navigate(['navigation']);
  }

  async exitDialog() {
    const confirmResult = await PopupHelper.exitSystemHelper();

    if (confirmResult === ConfirmResult.Ok) {
      this.router.navigate(['exit']);
    }
  }

  private convertDateToString(date: any, baseCentury: number, mask: string = null): string {
    return new DateHandler(date, baseCentury).format(mask);
  }

  get startDate() { return this.reportsPageForm.get('startDate'); }
  get endDate() { return this.reportsPageForm.get('endDate'); }
  get invoiceNumber() { return this.reportsPageForm.get('invoiceNumber'); }
  get openReportInTab() { return this.reportsPageForm.get('openReportInTab'); }

  showInvoiceReportGenerator = false;
  reportsPageForm: FormGroup;
  private formControl: FormControl;
}



// WEBPACK FOOTER //
// ./src/app/reports/reports.component.ts